import React, { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import logo from '../logo-total-energies.png';
import { FaTachometerAlt, FaGasPump, FaCogs, FaBook, FaBoxes, FaUsers, FaCalculator, FaMoneyBillWave, FaFileInvoiceDollar, FaReceipt, FaMoneyCheckAlt, FaBell, FaChartLine, FaChartBar, FaGlobeAfrica, FaUsersCog, FaClipboardList, FaUserCircle, FaSignOutAlt } from 'react-icons/fa';

const GLOBAL_ROLES = ['superadmin', 'admin_siege', 'comptable', 'financier', 'fiscaliste', 'auditeur'];

const AdminLayout: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const handleLogout = () => { logout(); navigate('/login'); };
  const isGlobal = user && GLOBAL_ROLES.includes(user.role);

  return (
    <div className="admin-layout">
      <aside className={`sidebar ${collapsed ? 'mini' : ''}`}>
        <div className="sidebar-header" onClick={() => setCollapsed(!collapsed)} style={{ cursor: 'pointer' }}>
          {collapsed ? (
            <img src={logo} alt="TotalEnergies" style={{ width: 36 }} />
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <img src={logo} alt="TotalEnergies" style={{ width: 42 }} />
              <span className="logo-text">StationFlow</span>
            </div>
          )}
        </div>

        {user && !collapsed && (
          <div style={{ padding: '12px 20px', borderBottom: '1px solid rgba(255,255,255,0.15)', fontSize: 13 }}>
            <div style={{ fontWeight: 600 }}>{user.prenom} {user.nom}</div>
            <div style={{ opacity: 0.7, fontSize: 11 }}>{user.role}</div>
          </div>
        )}

        <div className="sidebar-section">
          <NavLink to="/admin" end className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaTachometerAlt /></span> <span>Tableau de bord</span>
          </NavLink>
        </div>

        <div className="sidebar-section">
          <div className="sidebar-section-title">Exploitation</div>
          {isGlobal && (
            <NavLink to="/admin/stations" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaGasPump /></span> <span>Stations</span>
            </NavLink>
          )}
          <NavLink to="/admin/releves" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaCogs /></span> <span>Releves Pompes</span>
          </NavLink>
          <NavLink to="/admin/journaux" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaBook /></span> <span>Journaux Gerant</span>
          </NavLink>
          <NavLink to="/admin/inventaire" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaBoxes /></span> <span>Inventaire</span>
          </NavLink>
          {isGlobal && (
            <NavLink to="/admin/rh" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaUsers /></span> <span>Ressources Humaines</span>
            </NavLink>
          )}
        </div>

        {isGlobal && (
          <div className="sidebar-section">
            <div className="sidebar-section-title">Comptabilite & Finances</div>
            <NavLink to="/admin/comptabilite" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaCalculator /></span> <span>Comptabilite</span>
            </NavLink>
            <NavLink to="/admin/finances" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaMoneyBillWave /></span> <span>Finances</span>
            </NavLink>
            <NavLink to="/admin/fiscalite" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaFileInvoiceDollar /></span> <span>Fiscalite</span>
            </NavLink>
            <NavLink to="/admin/depenses" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaReceipt /></span> <span>Depenses & Charges</span>
            </NavLink>
            <NavLink to="/admin/paie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaMoneyCheckAlt /></span> <span>Gestion de la Paie</span>
            </NavLink>
          </div>
        )}

        <div className="sidebar-section">
          <div className="sidebar-section-title">Suivi</div>
          <NavLink to="/admin/alertes" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaBell /></span> <span>Alertes</span>
          </NavLink>
          {isGlobal && (
            <NavLink to="/admin/reporting" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaChartLine /></span> <span>Reporting</span>
            </NavLink>
          )}
          {isGlobal && (
            <NavLink to="/admin/analytics" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaChartBar /></span> <span>Analytics</span>
            </NavLink>
          )}
          {isGlobal && (
            <NavLink to="/admin/cartographie" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaGlobeAfrica /></span> <span>Cartographie</span>
            </NavLink>
          )}
        </div>

        {isGlobal && (
          <div className="sidebar-section">
            <div className="sidebar-section-title">Administration</div>
            <NavLink to="/admin/users" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaUsersCog /></span> <span>Utilisateurs</span>
            </NavLink>
            <NavLink to="/admin/audit" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="icon"><FaClipboardList /></span> <span>Journal d'audit</span>
            </NavLink>
          </div>
        )}

        <div className="sidebar-section">
          <NavLink to="/admin/profile" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="icon"><FaUserCircle /></span> <span>Mon Profil</span>
          </NavLink>
        </div>

        <div style={{ marginTop: 'auto', padding: '10px 0', borderTop: '1px solid rgba(255,255,255,0.15)' }}>
          <button onClick={handleLogout} className="sidebar-link" style={{ width: '100%', border: 'none', background: 'none', color: '#fff', cursor: 'pointer', textAlign: 'left', font: 'inherit' }}>
            <span className="icon"><FaSignOutAlt /></span> <span>Deconnexion</span>
          </button>
        </div>
      </aside>

      <div className={`main-content ${collapsed ? 'mini' : ''}`}>
        <div className="top-bar">
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={logo} alt="TotalEnergies" style={{ height: 30 }} />
            <h1>StationFlow</h1>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
            <span style={{ color: '#666', fontSize: 14 }}>
              {user ? `${user.prenom} ${user.nom}` : ''}
            </span>
            <button onClick={handleLogout} className="btn-logout">Deconnexion</button>
          </div>
        </div>
        <div className="page-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;
